// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"eb4c6fdf","336":"8f79ff56"}[chunkId] + ".chunk.js";
};